<template>
	<div>
		<el-dialog
				:title="showType"
				:visible.sync="dialogVisiable"
				:close-on-click-modal="false"
				:modal-append-to-body="false"
				@close="submitCancel"
				width="500px"
				center
		>
			<el-form
					size="small"
					ref="personForm"
					:rules="rules"
					label-width="80px"
					:model="personForm"
					:disabled="isshowdetail"
					@submit.native.prevent
			>
				<el-form-item label="姓名" :prop="isshowdetail ? '' : 'userName'">
					<el-input
							v-model.trim="personForm.userName"
							:disabled="editFlag"
							placeholder="请填写姓名"
							maxlength="20"
					></el-input>
				</el-form-item>
				<el-form-item label="手机号" :prop="isshowdetail ? '' : 'mobilePhone'">
					<el-input
							maxlength="11"
							v-model="personForm.mobilePhone"
							placeholder="请填写手机号"
					></el-input>
				</el-form-item>
				<el-form-item label="角色类型" :prop="isshowdetail ? '' : 'roleType'">
					<el-select
							placeholder="请选择角色类型"
							v-model="personForm.roleType"
							@change="roleChange"
							collapse-tags
							style="width: 100%"
					>
						<el-option
								:label="item.label"
								:value="item.value"
								v-for="(item, index) in roleList"
								:key="index"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属机构" :prop="isshowdetail ? '' : 'orgName'">
					<el-select placeholder="请选择所属机构" v-model="personForm.orgId" style="width: 100%" @change="orgChanged">
						<el-option label="广州市劳动人事争议仲裁委" value="1000029"></el-option>
						<el-option label="南沙区劳动人事争议仲裁委" value="1000030"></el-option>
					</el-select>
<!--					<el-input v-model.trim="personForm.orgName" maxlength="30"></el-input>-->
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="btn" type="primary" v-if="!isshowdetail" :loading="submitLoading" @click.prevent="submitForm">保存</el-button>
				<el-button class="btn" @click.prevent="submitCancel">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		insertBackstageUser,
		updateBackstageUser,
		listBackstageUser
	} from "@/api/person";
	export default {
		name: "personDialog",
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			detailInfo: {
				type: Object,
				default: () => ({})
			},
			showType: {
				type: String,
				default: "新增"
			}
		},
		data() {
			var validatePhone = (rule, value, callback) => {
				var myreg = /^1[3-9]\d{9}$/;
				if (!myreg.test(value)) {
					callback(new Error("手机号格式错误"));
				} else {
					callback();
				}
			};
			return {
				submitLoading: false,
				isshowdetail: false,
				personForm: {
					userName: "",
					mobilePhone: "",
					roleType: "",
					orgId: "",
					orgName: ""
				},
				roleList: [
					{
						value: "MEDIATOR",
						label: "仲裁员"
					},
					{
						value: "CLERK",
						label: "书记员"
					},
					{
						value: "MANAGE",
						label: "管理员"
					}
				], //角色类型列表
				rules: {
					userName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
					mobilePhone: [
						{ required: true, message: "请填写11位手机号码", trigger: "blur" },
						{ validator: validatePhone, trigger: "blur" }
					],
					roleType: [
						{ required: true, message: "请选择角色类型", trigger: "change" }
					]
				},
				editFlag: false,
				roleobjlist: []
			};
		},

		computed: {
			dialogVisiable: {
				get() {
					return this.visible;
				},
				set(val) {
					this.$emit("update:visible", val);
				}
			}
		},
		watch: {
			dialogVisiable: {
				handler: function(newval, oldval) {
					if (newval) {
						this.isshowdetail = this.showType === "查看";
						if (this.showType != "新增") {
							this.getdetail(this.detailInfo);
							this.editFlag = true;
						} else {
							this.personForm = {
								userName: "",
								mobilePhone: "",
								roleType: "",
								orgId: "",
								orgName: ""
							};
							this.editFlag = false;
						}
					}
				},
				deep: true
			}
		},
		methods: {
			orgChanged(val) {
				console.log('orgChanged', val)
				this.personForm.orgName = val=='1000029'? '广州市劳动人事争议仲裁委' : '南沙区劳动人事争议仲裁委'
			},
			roleChange(val) {
				console.log(val);
				this.roleobjlist = [];
				for (let i = 0; i < this.roleList.length; i++) {
					if (this.roleList[i].value === val) {
						let obj = {
							roleName: "",
							roleCode: "",
							organizationId: null,
							organizationName: "",
							areaCode: null,
							areaFullName: null
						};
						obj.roleName = val;
						obj.roleCode = this.roleList[i].value;
						this.roleobjlist.push(obj);
					}
				}
				console.log(this.roleobjlist);
			},
			submitForm() {
				this.$refs["personForm"].validate(valid => {
					if (valid) {
						this.submitLoading = true;
						this.roleobjlist.forEach(item => {
							item.organizationId = this.personForm.orgId;
							item.organizationName = this.personForm.orgName;
						});
						let params = {
							userName: this.personForm.userName,
							mobilePhone: this.personForm.mobilePhone,
							userId: this.showType === "新增" ? "" : this.detailInfo.userId,
							userRoleRelation: this.roleobjlist
						};
						if (this.showType === "新增") {
							insertBackstageUser(params).then(
									res => {
										if (res.data.code === 1000) {
											this.$message({
												type: "success",
												message: "保存成功"
											});
											this.submitCancel();
											this.$emit("getPersonList");
										} else {
											this.$message({
												type: "error",
												message: res.data.message
											});
										}
									},
									err => {}
							);
						} else {
							updateBackstageUser(params).then(
									res => {
										if (res.data.code === 1000) {
											this.$message({
												type: "success",
												message: "保存成功"
											});
											this.submitCancel();
											this.$emit("getPersonList");
										} else {
											this.$message({
												type: "error",
												message: res.data.message
											});
										}
									},
									err => {}
							);
						}
						this.submitLoading = false;
					} else {
						return false;
					}
				});
			},
			submitCancel() {
				this.dialogVisiable = false;
				this.$refs["personForm"].resetFields();
				this.personForm = {
					userName: "",
					mobilePhone: "",
					roleType: "",
					orgName: "广州市劳动人事争议仲裁院"
				};
			},
			getdetail(item) {
				console.log(item);
				this.personForm.userName = item.userName;
				this.personForm.mobilePhone = item.mobilePhone;
				this.personForm.roleType = item.userRole[0].roleCode;
				this.personForm.orgId = item.orgId.toString();
				this.personForm.orgName = item.orgName;
				this.roleChange(this.personForm.roleType);
			}
		}
	};
</script>

<style lang="scss">
	.el-input--small .el-input__inner {
		height: 40px;
		line-height: 32px;
	}
	.el-dialog__header {
		min-height: 53px;
		padding: 0px;
		border-bottom: 1px solid #e6e6e6;
		box-sizing: border-box;
	}
	.dialog-footer {
		margin-top: -40px;
		.btn {
			width: 100px;
			border-radius: 4px !important;
		}
	}
</style>


